import Common from '../../../../Common';

interface Body {
	pbx_did_id?: id | null
}

const Did = class extends Common {
	create = (companyId: id, id: id, body: Body) =>
		this.post(`/company/${companyId}/pbxdad/flow/${id}/did`, body)

	delete = (companyId: id, id: id, didId: id) =>
		this.doDelete(`/company/${companyId}/pbxdad/flow/${id}/did/${didId}`)
}

export default Did
